import { Stack, Typography } from '@rossum/ui/material';

type QueueColumnProps = {
  queueName: string | undefined;
  workspaceName: string | undefined;
};

export const QueueColumn = ({ queueName, workspaceName }: QueueColumnProps) => {
  if (!queueName) return null;

  return (
    <Stack
      sx={{
        maxWidth: '100%',
        height: '100%',
        justifyContent: 'center',
      }}
    >
      <Typography
        color="secondary"
        variant="body2"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '100%',
        }}
      >
        {queueName}
      </Typography>
      {workspaceName && (
        <Typography
          color="text.secondary"
          variant="caption"
          fontWeight="700"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%',
          }}
        >
          {workspaceName}
        </Typography>
      )}
    </Stack>
  );
};
